import { render } from "./giftList.vue?vue&type=template&id=03533d4c&scoped=true"
import script from "./giftList.vue?vue&type=script&lang=js"
export * from "./giftList.vue?vue&type=script&lang=js"

import "./giftList.vue?vue&type=style&index=0&id=03533d4c&lang=scss&scoped=true"
import "./giftList.vue?vue&type=style&index=1&id=03533d4c&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03533d4c"]])

export default __exports__